import { Steps, StepsChangeDetails } from "@chakra-ui/react";
import { Dispatch, ReactNode, SetStateAction } from "react";
import { v4 } from "uuid";

interface Step {
  title: string;
  content?: ReactNode;
}

interface Props {
  steps: Step[];
  currentStep: number;
  disableStep?: boolean;
  setCurrentStep: Dispatch<SetStateAction<number>>;
}

export const StepperComponent = ({
  steps,
  currentStep,
  disableStep,
  setCurrentStep,
}: Props) => {
  const handleStep = (step: StepsChangeDetails) => {
    setCurrentStep(step.step);
  };

  return (
    <Steps.Root
      defaultStep={1}
      count={steps.length}
      step={currentStep}
      onStepChange={handleStep}
      colorPalette={"current"}
    >
      <Steps.List>
        {steps.map((step, index) => (
          <Steps.Item key={v4()} index={index} title={step.title}>
            <Steps.Trigger cursor="pointer" disabled={disableStep}>
              <Steps.Indicator />
              <Steps.Title>{step.title}</Steps.Title>
            </Steps.Trigger>

            <Steps.Separator />
          </Steps.Item>
        ))}
      </Steps.List>

      {steps.map((step, index) => (
        <Steps.Content key={v4()} index={index}>
          {step.content}
        </Steps.Content>
      ))}
    </Steps.Root>
  );
};
